import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LegalFooter } from "./LegalFooter";

export const Logo = () => (
  <Link to="/" className="flex items-center gap-2 min-w-0" data-testid="nav-logo-link">
    <img src="/logo-header.png" alt="Social Betting" className="h-10 w-10 shrink-0 rounded-xl object-cover" data-testid="nav-logo-image" />
    <span className="font-display text-xl sm:text-2xl font-extrabold uppercase tracking-tight text-white whitespace-nowrap">
      Social<span className="text-emerald-400">Betting</span>
    </span>
  </Link>
);

export const AppShell = ({ children }) => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen pitch-bg">
      <header className="sticky top-0 z-30 bg-[#0A0D14] border-b border-[#26334D] shadow-lg shadow-black/30">
        <div className="max-w-7xl mx-auto px-3 sm:px-8 h-16 flex items-center justify-between gap-3">
          <Logo />
          <div className="flex items-center gap-2 sm:gap-4 shrink-0">
            <Link to="/profile" data-testid="nav-profile-link" className="flex items-center gap-2 sm:gap-3 rounded-full pr-1 sm:pr-3 hover:bg-[#182030] transition-colors">
              <span className="h-8 w-8 rounded-full bg-[#26334D] grid place-items-center font-display font-bold text-white" data-testid="nav-user-avatar">
                {user?.name?.[0]?.toUpperCase()}
              </span>
              <span className="hidden md:inline text-sm text-white" data-testid="nav-user-name">{user?.name}</span>
              <span className="hidden sm:inline text-xs font-mono uppercase tracking-widest text-emerald-400">Profilo</span>
            </Link>
            <button onClick={logout} data-testid="logout-button" className="h-10 min-w-10 px-2 sm:px-0 grid sm:flex place-items-center items-center gap-1.5 text-sm text-slate-200 hover:text-red-400 transition-colors">
              <LogOut size={16} /> <span className="hidden sm:inline">Esci</span>
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-3 sm:px-8 py-5 sm:py-12">{children}</main>
      <LegalFooter />
    </div>
  );
};
